import { Editor, Node, Path, Transforms } from 'slate';

export const clearCoverage = (editor: Editor, path: Path): void => {
  Transforms.unsetNodes(editor, 'coverage' as keyof Node, { at: path });
};
